function Loading({isLoading}) {
  return (
      <div
              style={{
                  width: '100vw',
                  height: '100vh',
                  background: 'black',
                  position: 'fixed',
                  margin: 0,
                  padding: 0,
                  top: 0,
                  left: 0,
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
              }}
          >
              {isLoading ?
              <div
                  style={{
                      border: '8px solid #f3f3f3', /* Light gray */
                      borderTop: '8px solid #3498db', /* Blue */
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      animation: 'spin 1s linear infinite',
                  }}
              ></div>
              :
              <h1>
                  Photo not found
              </h1>
              }
  
              <style>
                  {`
                      @keyframes spin {
                          0% { transform: rotate(0deg); }
                          100% { transform: rotate(360deg); }
                      }
                  `}
              </style>
          </div>
  )
}

export default Loading;